import './polyfills';
import Vue from 'vue';
import './services/axiosErrorInterceptor';
import './services/axiosLogInterceptor';
import TjipVue from '@tjip/vuejs';
import Vuelidate from 'vuelidate';
import BootstrapVue from 'bootstrap-vue';
import 'popper.js';
import i18n from './i18n';
import './log';
import './icons';
import App from './App.vue';
// Need to load AuthService before store !!
// When store is loaded first it's dependencies will try to use AuthService during loading
// However AuthService in turn depends on store
import './services/AuthService';
import store from './store';
import router from './router';
import init from './init';
import AppComponents from './components';
import AppDirectives from './directives';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@tjip/vuejs/tjip-vuejs.css';
import './style/style.scss';
import './style/style-layout-site.scss';

Vue.config.productionTip = false;
Vue.use(TjipVue);
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(AppComponents);
Vue.use(AppDirectives);

init();

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
